import RequisitionsImportCont from '../../../../components/Corporate/Requisitions/RequisitionsImportCont'
import DuplicateLineButton from '../../../../elements/DuplicateLineButton'
import GroupLinesButton from '../../../../elements/GroupLinesButton'
import React, { Fragment } from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Button } from 'antd'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'
import SumFooter from '../../../../elements/Table/Footers/SumFooter'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'

const CheckboxTable = checkboxHOC(CustomTable)

function List(props) {
  const {
    list,
    fetch,
    isUpdatable,
    fetching,
    onShow,
    isSelected,
    toggleSelection,
    tableRef,
    setSelection,
    removingBulk,
    selection,
    removeSelection,
    removing,
    selectAll,
    requisition,
    toggleAll,
    groupAllowed,
  } = props

  const checkboxProps = {
    selectType: 'checkbox',
    selectAll,
    isSelected,
    toggleSelection,
    toggleAll,
  }

  const columns = [
    {
      Header: 'ID',
      accessor: '_key',
      width: 180,
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    {
      Header: 'No',
      accessor: 'no',
      width: 80,
    },
    {
      Header: 'Group',
      accessor: 'groupLink',
      Cell: ({ value, original }) => value || 'No Group',
      width: 80,
    },
    {
      Header: 'Name',
      accessor: 'name',
      width: 300,
    },
    {
      Header: 'Description',
      accessor: 'description',
      width: 300,
      hideable: true,
      hideDefault: true,
    },
    { Header: 'Unit', accessor: 'unit', width: 80 },
    { Header: 'Ordered', accessor: 'ordered', width: 80, hideable: true, hideDefault: true },
    { Header: 'uom', accessor: 'uom.code', width: 80 },
    {
      Header: 'rate',
      accessor: 'rate',
      width: 120,
      Cell: MoneyCell,
      Footer: SumFooter,
    },
    {
      Header: 'Max amount',
      accessor: 'max',
      Cell: MoneyCell,
      Footer: SumFooter,
      width: 120,
    },
    {
      Header: 'BudgetLine',
      accessor: 'budgetLine.name',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Vendor',
      accessor: 'vendor.fn',
      hideable: true,
      hideDefault: false,
      width: 200,
    },
    {
      Header: 'Vendor SKU',
      accessor: 'vendorNo',
      hideable: true,
      hideDefault: false,
      width: 150,
    },
    {
      Header: 'OEM',
      accessor: 'materials.oem.name',
      hideable: true,
      hideDefault: false,
      width: 200,
    },
    {
      Header: 'OEM Part No',
      accessor: 'materials.oem.partNo',
      hideable: true,
      hideDefault: true,
      width: 150,
    },
    {
      Header: 'DWG',
      accessor: 'materials.oem.dwgNo',
      hideable: true,
      hideDefault: true,
      width: 150,
    },
    {
      Header: 'From Stock',
      accessor: 'purchase.fromStock',
      hideable: true,
      hideDefault: true,
    },
  ]

  console.log({ groupAllowed })
  return (
    <CheckboxTable
      {...checkboxProps}
      withRef={tableRef}
      data={list}
      isFilterable={true}
      fetching={fetching || removingBulk}
      fetch={fetch}
      CreateButton={() => (
        <>
          <Button
            data-testid={'add'}
            type={'primary'}
            size="small"
            icon={'plus'}
            disabled={!isUpdatable}
            onClick={onShow}>
            New{' '}
          </Button>
          <Button
            size={'small'}
            type={'danger'}
            loading={removing}
            onClick={removeSelection}
            disabled={selection.length === 0 || !isUpdatable}
            style={{ marginLeft: '10px' }}>
            Remove Selection
          </Button>
          <DuplicateLineButton
            selection={selection || !isUpdatable}
            fetch={fetch}
            setSelection={setSelection}
            disabled={selection.length === 0}
          />

          <GroupLinesButton
            selection={selection || !isUpdatable}
            fetch={fetch}
            setSelection={setSelection}
            disabled={selection.length === 0 || !groupAllowed}
          />
          <RequisitionsImportCont {...{ requisition, fetch }} />
        </>
      )}
      defaultSorted={[
        {
          id: 'no',
          desc: false,
        },
      ]}
      columns={columns}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
